export const GET_EMAIL_ATTCH_LIST = 'GET_EMAIL_ATTCH_LIST'
export const GET_EMAIL_ATTCH_LIST_SUCCESS = 'GET_EMAIL_ATTCH_LIST_SUCCESS'
export const GET_EMAIL_ATTCH_LIST_FAILED = 'GET_EMAIL_ATTCH_LIST_FAILED'

export const ADD_EMAIL_ATTCH = 'ADD_EMAIL_ATTCH'
export const ADD_EMAIL_ATTCH_SUCCESS = 'ADD_EMAIL_ATTCH_SUCCESS'
export const ADD_EMAIL_ATTCH_FAILED = 'ADD_EMAIL_ATTCH_FAILED'

export const EDIT_EMAIL_ATTCH = 'EDIT_EMAIL_ATTCH'
export const EDIT_EMAIL_ATTCH_SUCCESS = 'EDIT_EMAIL_ATTCH_SUCCESS'
export const EDIT_EMAIL_ATTCH_FAILED = 'EDIT_EMAIL_ATTCH_FAILED'

export const DELETE_EMAIL_ATTCH = 'DELETE_EMAIL_ATTCH'
export const DELETE_EMAIL_ATTCH_SUCCESS = 'DELETE_EMAIL_ATTCH_SUCCESS'
export const DELETE_EMAIL_ATTCH_FAILED = 'DELETE_EMAIL_ATTCH_FAILED'

export const DOWNLOAD_EMAIL_ATTCH = 'DOWNLOAD_EMAIL_ATTCH'
export const DOWNLOAD_EMAIL_ATTCH_SUCCESS = 'DOWNLOAD_EMAIL_ATTCH_SUCCESS'
export const DOWNLOAD_EMAIL_ATTCH_FAILED = 'DOWNLOAD_EMAIL_ATTCH_FAILED'
